import Linked from 'shared-components/service/Linked'
import styles from './CategoryLandingTemplate.module.css'
import Breadcrumbs from 'components/product/Breadcrumbs'
import type { DealHuntCategory } from 'lib/dealhunt/types'
import { dealHuntCategoryHref } from 'lib/dealhunt/url'
import { publicConfig } from 'config'

interface CategoryLandingTemplateProps {
  data: DealHuntCategory
}

/**
 * Phase 1 category landing: breadcrumbs, hero, and subcategory tiles. The full
 * filtered browse experience (price/brand/spec facets, sort, grid) lands in
 * Phase 2 on this same route.
 */
const CategoryLandingTemplate: React.VFC<CategoryLandingTemplateProps> = ({ data }) => {
  const trailingSlash = publicConfig('useTrailingSlash')
  return (
    <div className={styles.page}>
      <Breadcrumbs items={data.breadcrumbs} />
      <header className={styles.hero}>
        <h1 className={styles.title}>{data.node.name}</h1>
        {data.node.heroSubtitle && <p className={styles.subtitle}>{data.node.heroSubtitle}</p>}
      </header>

      {data.subcategories.length > 0 && (
        <div className={styles.grid}>
          {data.subcategories.map(sub => (
            <Linked
              key={sub.id}
              href={dealHuntCategoryHref(sub.fullSlug, trailingSlash)}
              className={styles.tile}
            >
              <span className={styles.tileImage}>
                {sub.imageUrl ? (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={sub.imageUrl} alt={sub.name} width={400} height={300} loading="lazy" />
                ) : (
                  <span className={styles.tileImageEmpty} aria-hidden="true" />
                )}
              </span>
              <span className={styles.tileName}>{sub.name}</span>
              <span className={styles.tileCount}>
                {sub.productCount}
                {' products'}
              </span>
            </Linked>
          ))}
        </div>
      )}
    </div>
  )
}

export default CategoryLandingTemplate
